import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const KEY = "vomi-b2b-locale";

export async function getStoredLocale(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key: KEY });
    return value;
  }
  return localStorage.getItem(KEY);
}

export async function setStoredLocale(locale: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: KEY, value: locale });
  } else {
    localStorage.setItem(KEY, locale);
  }
}
